import { useEffect, useState } from 'react'
import { getWipReportsByProjectIds } from '../../entities/project/service'
import { removeTypename } from '../../utils/removeTypename'

const useWipData = ({ client, projects = [], selectedProject, months, selectedMonth }) => {
  const [allProjectsWipReports, setAllProjectsWipReports] = useState([])
  const [projectWipReports, setProjectWipReports] = useState()
  const [selectedMonthProjectWipReport, setSelectedMonthProjectWipReport] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchWipReports = async () => {
      if (!projects.length || !client) return

      setIsLoading(true)
      try {
        const projectIds = projects.map(project => project._id).join(',')

        const result = (await getWipReportsByProjectIds(client, projectIds, months)) || []

        setAllProjectsWipReports(result)
      } catch (error) {
        console.error('Error fetching WIP reports:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchWipReports()
  }, [client, projects, months])

  useEffect(() => {
    if (!selectedProject) return

    const reports = allProjectsWipReports.find(report => report.projectId === selectedProject._id)

    setProjectWipReports(reports)
  }, [allProjectsWipReports, selectedProject])

  useEffect(() => {
    const report = projectWipReports?.monthlyWipReports?.find(report => {
      if (!report) {
        return false
      }
      return report.month === selectedMonth
    })

    const cleanReport = removeTypename(report)
    setSelectedMonthProjectWipReport(cleanReport)
  }, [projectWipReports, selectedMonth])

  return { selectedMonthProjectWipReport, projectWipReports, isLoading }
}

export default useWipData
